/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { networkIngressGetIngress } from "../funcs/networkIngressGetIngress.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { NetworkIngressResult } from "../models/components/networkingressresult.js";
import {
  GetNetworkIngressRequest,
  GetNetworkIngressSecurity,
} from "../models/operations/getnetworkingress.js";
import { unwrapAsync } from "../types/fp.js";
export type NetworkIngressQueryData = NetworkIngressResult;

export function prefetchNetworkIngress(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetNetworkIngressRequest | undefined,
  security?: GetNetworkIngressSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildNetworkIngressQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildNetworkIngressQuery(
  client$: GramCore,
  request?: GetNetworkIngressRequest | undefined,
  security?: GetNetworkIngressSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<NetworkIngressQueryData>;
} {
  return {
    queryKey: queryKeyNetworkIngress({ gramSession: request?.gramSession }),
    queryFn: async function networkIngressQueryFn(
      ctx,
    ): Promise<NetworkIngressQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(networkIngressGetIngress(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyNetworkIngress(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "networkIngress", "getIngress", parameters];
}
